import React, { useState, useEffect } from "react";
import get from "lodash/get";
import { withTranslation } from "react-i18next";
import withRouter from "../../HOC/withRouter";
import { connect } from "react-redux";
import { compose } from "react-recompose";
import { authActionCreators, userActions } from "../../store/actions";
import { promisify } from "../../utils/promisify";
import ChallengesToDoIcon from "../../components/svgs/ChallengesToDoIcon";
import ClickArrowIcon from "../../components/svgs/ClickArrowIcon";
import TaskInfoContainer from "./TaskInfoContainer";

const TasksList = ({
  t,
  navigate,
  touchpoints,
  client,
  profile,
  allTasks,
  getTasks,
  challengeModalVisible,
  onCancel,
  tasks,
}) => {
  useEffect(() => {
    promisify(getTasks, {});
  }, []); //eslint-disable-line react-hooks/exhaustive-deps

  const TPNames = touchpoints && touchpoints.reduce((acc, cur) => ({ ...acc, [cur._id]: cur.name }), {});
  const activeChallenges =
    get(allTasks, "user.current", []).filter(t => t.completionLevel < t.quantity).length +
    get(allTasks, "workspace.current", []).filter(t => t.workspaceCompletionLevel < t.quantity).length;
  const uncheckedTasks = JSON.parse(localStorage.getItem("uncheckedTasks"));
  const [uncheckedUserTasks, setUncheckedUserTasks] = useState(
    uncheckedTasks && uncheckedTasks[profile._id] ? new Set(uncheckedTasks[profile._id]) : new Set(),
  );
  const [, setTimeStamp] = useState();
  const unfinishedTasks = tasks.filter(t => t.completionLevel < t.quantity);
  const todoChallengesCount = activeChallenges - unfinishedTasks.length;
  const countType = todoChallengesCount > 1 ? "plural" : "singular";

  const handleNotifications = id => {
    const updatedTasks = uncheckedUserTasks;
    if (updatedTasks.has(id)) {
      updatedTasks.delete(id);
    } else {
      updatedTasks.add(id);
    }
    setUncheckedUserTasks(updatedTasks);
    setTimeStamp(Date.now());
    const newUncheckedTasks = { ...uncheckedTasks };
    if (updatedTasks.size > 0) {
      newUncheckedTasks[profile._id] = [...updatedTasks];
    } else {
      delete newUncheckedTasks[profile._id];
    }
    localStorage.setItem("uncheckedTasks", JSON.stringify(newUncheckedTasks));
  };

  const viewChallenges = () => {
    onCancel();
    navigate("/tasks");
  };

  return (
    <div className="notifications-modal">
      <div className="modal-header">
        <span className="modal-header-label">{t("challengeModal.HeaderLabel")}</span>
        <div className="close-icon" onClick={onCancel}>
          &#10006;
        </div>
      </div>
      <div className="modal-body page-our-brand">
        {tasks &&
          tasks.map(task => (
            <TaskInfoContainer
              key={task._id}
              t={t}
              task={task}
              uncheckedTasks={uncheckedUserTasks}
              TPNames={TPNames}
              profileId={profile._id}
              challengeModalVisible={challengeModalVisible}
              handleNotifications={handleNotifications}
              onCancel={onCancel}
            />
          ))}
        {todoChallengesCount > 0 && (
          <div className="challenges-to-do-info" onClick={viewChallenges}>
            <span className="to-do-icon">
              <ChallengesToDoIcon color={client?.altColor} />
            </span>
            <div className="challenges-to-do-text">
              <span>{t(`challengeModal.ToDoTextPart1`)}</span>
              <span className="highlighted">
                {t(`challengeModal.ToDoTextPart2.${countType}`, { count: todoChallengesCount })}
              </span>
            </div>
            <span className="click-icon">
              <ClickArrowIcon color={client?.altColor} />
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  profile: state.user.profile,
  touchpoints: state.touchPoint.touchPoints,
  allTasks: state.user.tasks,
  client: state.client.client,
});

export default compose(
  withRouter,
  connect(mapStateToProps, authActionCreators),
  connect(null, userActions),
)(withTranslation()(TasksList));
